import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Page_BaseManagerUI_SingleType_Proto, Renderer_SearchResult, SearchItemV3_With_ID, SearchSelector_BaseManagerUI } from '@app/styles';
import { RoutePermissions } from '@nu-art/permissions-frontend/index';
import { TS_HorizontalWorkspace } from '@nu-art/ts-workspace-frontend/index';
import { AccessLevel, ModuleFE_PermissionsAssert } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
import { QPageMessage } from '../q-components/index.js';
import { ModuleFE_ContextRule, ModulePackFE_ContextRuleDB } from '../../_entity/context-rule/index.js';
import { ModuleFE_HCSPermissions } from '../../permissions/index.js';
import { Component_ContextRuleEntityEditor } from './Component_ContextRuleEntityEditor/Component_ContextRuleEntityEditor.js';
import { workspaceKey_ContextRulesSearch } from './workspace-config.js';
import { Dialog_CompareRules } from './Dialog_CompareRules/Dialog_CompareRules.js';
import { ModuleFE_Tag } from '../../_entity/tag/index.js';
const ManagerKey_ContextRules = 'context-rules-manager';
export class Page_ContextRulesManager extends Page_BaseManagerUI_SingleType_Proto {
    // ######################## Static ########################
    static Route = {
        key: ManagerKey_ContextRules,
        path: 'context-rules',
        Component: this,
        enabled: RoutePermissions(ModuleFE_HCSPermissions.permissions.ui.Release),
        modulesToAwait: [...ModulePackFE_ContextRuleDB, ModuleFE_Tag],
    };
    static searchItemKey_ContextRules = ModuleFE_ContextRule.dbDef.dbKey;
    static SearchableItem_ContextRules = SearchItemV3_With_ID({
        module: ModuleFE_ContextRule,
        type: Page_ContextRulesManager.searchItemKey_ContextRules,
        route: Page_ContextRulesManager.Route,
        entityName: ModuleFE_ContextRule.dbDef.entityName,
        entityLabel: 'Context Rule',
        groupId: ['Healthcare Space'],
        mapper: (item) => [(item.label && item.label.length) ? item.label : 'Missing Label'],
        tags: [],
        renderer: (item, selected, onClickCallback) => {
            return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: Page_ContextRulesManager.searchItemKey_ContextRules, itemLabel: item.label ?? item.description ?? 'Missing Label', entityLabel: 'Context Rule', onClickCallback: onClickCallback, selected: selected });
        },
        resultRenderer: (item) => {
            return _jsx(_Fragment, {});
        }
    });
    static defaultProps = {
        searchItems: [Page_ContextRulesManager.SearchableItem_ContextRules]
    };
    // ######################## Abstract Implementations ########################
    getInitialObject() {
        return Object.freeze({});
    }
    workspace = () => ({
        id: ManagerKey_ContextRules,
        key: workspaceKey_ContextRulesSearch,
        renderers: {
            horizontalSpace: TS_HorizontalWorkspace,
        },
        instances: {
            // search instances
            searchPanel: this.renderLeftPanel(),
            dataViewer: this.renderRightPanel(),
        }
    });
    renderLeftPanel = () => {
        const accessLevel = this.getAccessLevel();
        const buttons = AccessLevel.HasAccess === accessLevel ? [{
                label: 'Add New Context Rule',
                action: this.onCreateNewContextRule
            }, {
                label: 'Compare Context Rules',
                action: () => Dialog_CompareRules.show()
            }] : [];
        return _jsx(SearchSelector_BaseManagerUI, { selectedItem: this.state.selectedResult, onSearchItemSelected: (item) => this.onSearchResultSelected(item.id, item.type), searchItems: [Page_ContextRulesManager.SearchableItem_ContextRules], buttons: buttons });
    };
    renderRightPanel = () => {
        if (this.state.selectedItem)
            return _jsx(Component_ContextRuleEntityEditor, { deselect: () => this.setState({ selectedItem: undefined, selectedResult: undefined }), editable: this.state.selectedItem });
        return _jsx(QPageMessage, { message: 'Context Rules Manager' });
    };
    // ######################## Logic ########################
    onCreateNewContextRule = () => {
        this.clearSelectedResult();
        const newContextRule = this.getEditableItem();
        this.setState({
            selectedItem: newContextRule,
            selectedResult: undefined
        });
    };
    getAccessLevel() {
        return ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_HCSPermissions.permissions.collection.edit);
    }
}
//# sourceMappingURL=Page_ContextRulesManager.js.map